<template>
<div class="chapter">
<div class="inner_page">
<section class="SOM" epub:type="toc">
<h1 class="SOM_titre" epub:type="title">Contents</h1>
<div class="SOM_pre"><a href="#/pre4">Acknowledgments</a></div>
<div class="SOM_pre"><a href="#/pre5">Abbreviations</a></div>
<div class="SOM_pre"><a href="#/pre6">A Guide to Using this Commentary</a></div>
<div class="SOM_pre"><a href="#/pre7">General Introduction</a></div>
<div class="SOM_pre"><a href="#/pre8">Introduction to Joshua, Judges, Ruth</a></div>
<div class="SOM_part"><a href="#/p1">Commentary on Joshua</a></div>
<div class="SOM_part"><span href="#/p2" title="Link target outside of Sample">Commentary on Judges</span></div>
<div class="SOM_part"><span href="#/p3" title="Link target outside of Sample">Commentary on Ruth</span></div>
<div class="SOM_appen"><span href="#/appen9" title="Link target outside of Sample">Map of Europe at the Time of the Reformation</span></div>
<div class="SOM_appen"><span href="#/appen10" title="Link target outside of Sample">Timeline of the Reformation</span></div>
<div class="SOM_appen"><span href="#/appen11" title="Link target outside of Sample">Biographical Sketches of Reformation-Era Figures and Works</span></div>
<div class="SOM_appen"><span href="#/appen12" title="Link target outside of Sample">Sources For Biographical Sketches</span></div>
<div class="SOM_appen"><span href="#/appen13" title="Link target outside of Sample">Bibliography</span></div>
<div class="SOM_appen"><span href="#/appen14" title="Link target outside of Sample">Author and Writings Index</span></div>
<div class="SOM_appen"><span href="#/appen15" title="Link target outside of Sample">Subject Index</span></div>
<div class="SOM_appen"><span href="#/appen16" title="Link target outside of Sample">Scripture Index</span></div>
<div class="SOM_appen"><span href="#/appen17" title="Link target outside of Sample">Notes</span></div>
<div class="SOM_appen"><span href="#/appen18" title="Link target outside of Sample">Praise for <i>the Reformation Commentary on Scripture</i></span></div>
<div class="SOM_appen"><span href="#/appen19" title="Link target outside of Sample">About the Author</span></div>
<div class="SOM_pdf"><span href="#/fin_acheve" title="Link target outside of Sample">More Titles from InterVarsity Press</span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sommaire.vue?46a8c324